import { CONTACT } from "@/data/site";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F5F5F0] font-body">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 h-20 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3"><img src="/logo.png" alt="247 Aftermath" className="h-12 w-auto" /></a>
          <a href="/" className="text-sm text-[#A3A3A3] hover:text-gold transition-colors" data-testid="privacy-back">← Back to site</a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16" data-testid="privacy-page">
        <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Legal</span>
        <h1 className="font-display text-4xl sm:text-5xl mt-4 mb-2">Privacy Policy</h1>
        <p className="text-sm text-[#A3A3A3] mb-10">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>

        <div className="space-y-8 text-[#c9c9c4] leading-relaxed">
          <section>
            <p>247 Aftermath Restoration Mgmt Inc ("we", "us") respects your privacy. This policy explains what information we collect through our website and how we use it.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-[#F5F5F0] mb-3">Information We Collect</h2>
            <p>When you submit a service request, quote, or booking on our site, we collect the information you provide: your name, phone number, email address, property address, and details about your restoration needs.</p>
          </section>

          <section id="sms" className="border border-gold/25 bg-[#0d0d0d] p-6">
            <h2 className="font-display text-2xl text-[#F5F5F0] mb-3">SMS / Text Messaging Consent</h2>
            <p className="mb-3">By providing your phone number and submitting a request, quote, or booking form on this website, you expressly consent to receive SMS text messages from 247 Aftermath Restoration Mgmt at the mobile number you provided. These messages relate to your service request and appointments, including appointment confirmations, reminders, and follow-ups.</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Message frequency varies based on your interaction with us.</li>
              <li>Message and data rates may apply.</li>
              <li>Reply <strong className="text-gold">STOP</strong> at any time to opt out of text messages.</li>
              <li>Reply <strong className="text-gold">HELP</strong> for assistance, or call us at {CONTACT.phone}.</li>
              <li>Carriers are not liable for delayed or undelivered messages.</li>
            </ul>
            <p className="mt-3"><strong className="text-[#F5F5F0]">We do not sell or share your mobile number or SMS consent</strong> with third parties or affiliates for marketing purposes. Mobile information is used solely to contact you about your service with us.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-[#F5F5F0] mb-3">How We Use Your Information</h2>
            <p>We use your information to respond to your inquiry, schedule and service your restoration project, send confirmations and reminders, and provide customer support. We do not sell your personal information.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-[#F5F5F0] mb-3">Contact Us</h2>
            <p>Questions about this policy? Contact us:</p>
            <p className="mt-2">247 Aftermath Restoration Mgmt Inc<br />{CONTACT.address}<br />Phone: {CONTACT.phone}<br />Email: {CONTACT.email}</p>
          </section>
        </div>
      </main>
    </div>
  );
}
